import React from "react";
import { partners, program } from "../../data/program";
import { schedule } from "../../data/schedule";
import { programImage } from "../../data/site";
import { currentProgramDay, formatDay, PROGRAM_DAYS } from "../../utils/dates";
import { SectionHeading } from "./SectionHeading";
const blocks: Record<string, {
  label: string;
  col: string;
}> = {
  AM: {
    label: "Morning",
    col: "sm:col-start-1"
  },
  Lunch: {
    label: "Lunch · 12:00–13:30",
    col: "sm:col-start-2"
  },
  PM: {
    label: "Afternoon / evening",
    col: "sm:col-start-3"
  }
};
export function ProgramSection() {
  const today = currentProgramDay();
  return <section id="program" className="scroll-mt-20 bg-sun py-24 md:py-32" data-id="element-597" data-mp="2yn1tt7y4o86g">
      <div className="mx-auto max-w-[1400px] px-5 md:px-8" data-id="element-598" data-mp="33mn0y5ngbmu9">
        <SectionHeading title="Program partners" intro={program.summary} data-id="element-599" data-mp="33p98i5ace2ch" />

        <div className="mt-16 grid gap-10 lg:grid-cols-[1.1fr_1fr] lg:items-center" data-id="element-600" data-mp="1n7d4i9xeix2h">
          <img src={programImage} alt="Circuit boards, wiring and a 3D-printed prototype on a workbench" className="aspect-[4/3] w-full rounded-[28px] object-cover" data-id="element-601" data-mp="1s8sp60vo31kc" />
          <ul className="divide-y divide-ink/20 border-y border-ink/20" data-id="element-602" data-mp="273bcdkm25ccy">
            {partners.map(p => <li key={p.name} className="py-5" data-id="element-603" data-mp="2l2t5gc6dzbs4">
                <p className="text-[12px] font-bold uppercase tracking-wide text-ink/60" data-id="element-604" data-mp="2g1x1jym1bpmp">{p.role}</p>
                <p className="font-display text-4xl uppercase leading-tight" data-id="element-605" data-mp="2uz5zjb5ufrne">{p.name}</p>
                <p className="mt-1 text-[15px] text-ink/75" data-id="element-606" data-mp="2q0upp0fjth56">{p.description}</p>
              </li>)}
          </ul>
        </div>

        <h3 className="mt-24 font-display text-5xl uppercase md:text-6xl" data-id="element-607" data-mp="33qpsthrpp9az">Schedule</h3>
        <p className="mt-2 text-[13px] font-semibold uppercase tracking-wide text-ink/60" data-id="element-608" data-mp="2zrgxi8h0x3db">
          October 7 – 13, 2026 · Times in Pacific · Daily videos due 21:00
        </p>

        <ol className="mt-8 border-t-2 border-ink" data-id="element-609" data-mp="38rm2kbyqvpob">
          {schedule.map(d => {
          const isToday = d.day === today;
          const isDemo = d.day === PROGRAM_DAYS + 1;
          return <li key={d.day} className={`grid gap-5 border-b border-ink/25 py-8 lg:grid-cols-[180px_minmax(0,260px)_1fr] lg:gap-8 ${isDemo ? "bg-ink -mx-5 px-5 text-sun md:-mx-8 md:px-8" : ""}`} data-id="element-610" data-mp="2aehtyvv0zzo3">
                <div data-id="element-611" data-mp="2p4p5ssqj2kft">
                  <p className="font-display text-5xl uppercase leading-none" data-id="element-612" data-mp="2p34cf6fy97jj">{formatDay(d.day, "MMM dd")}</p>
                  <p className="mt-1 flex items-center gap-2 text-[12px] font-bold uppercase tracking-wide" data-id="element-613" data-mp="2u1xn6r3uqkg0">
                    {isDemo ? "Demo Day" : `Day ${String(d.day).padStart(2, "0")}`}
                    {isToday && <span className="rounded-full bg-tomato px-2 py-0.5 text-cream" data-id="element-614" data-mp="333f2w8dckk46">Today</span>}
                  </p>
                </div>
                <div data-id="element-615" data-mp="18pxobaux6xla">
                  <p className="font-display text-3xl uppercase leading-tight" data-id="element-616" data-mp="18pe57qtja35o">{d.theme}</p>
                  <p className={`mt-3 text-[11px] font-bold uppercase tracking-wide ${isDemo ? "text-sun/70" : "text-ink/60"}`} data-id="element-617" data-mp="116wrt9ije47f">
                    Goal for the day
                  </p>
                  <p className={`mt-0.5 text-[16px] font-semibold leading-snug ${isDemo ? "text-cream" : ""}`} data-id="element-618" data-mp="rgle4v91wgnc">{d.goal}</p>
                </div>
                <dl className="grid gap-x-8 gap-y-4 sm:grid-cols-[1fr_0.7fr_1.3fr]" data-id="element-619" data-mp="mitj3sd40eex">
                  {d.sessions.map(s =>
              // Each block keeps its own column, so a day without lunch stays aligned.
              <div key={s.time + s.title} className={blocks[s.time]?.col ?? ""} data-id="element-620" data-mp="1f437uwbvlosy">
                      <dt className={`text-[11px] font-bold uppercase tracking-wide ${isDemo ? "text-sun/70" : "text-ink/60"}`} data-id="element-621" data-mp="1a5i971c9vd6m">
                        {blocks[s.time]?.label ?? s.time}
                      </dt>
                      <dd className={`mt-1 text-[15px] leading-snug ${isDemo ? "text-cream" : ""}`} data-id="element-622" data-mp="3uv7lp7pi6mw5">{s.title}</dd>
                    </div>)}
                </dl>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}